import React from 'react';
import { HeartPulseIcon, AwardIcon, LayersIcon, PaletteIcon, TrophyIcon, CheckSquareIcon, SparklesIcon } from 'lucide-react';
export const ClosingSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-gradient-to-br from-white to-[#f7f3ef]" data-id="element-23">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-5 border-l-4 border-[#d4af37] pl-4" data-id="element-24">
        Samenvatting: Verfijnde Gamification
      </h2>
      <div className="flex items-center mb-5" data-id="element-25">
        <CheckSquareIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-26" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-27">
          Mosy's gamification-systeem is ontworpen om{' '}
          <span className="text-[#d4af37] font-medium" data-id="element-28">
            regelmatige check-ins
          </span>{' '}
          aan te moedigen met betekenisvolle beloningen die direct bijdragen aan
          het mentale welzijn.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5" data-id="element-29">
        <div className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-30">
          <div className="flex items-center mb-2" data-id="element-31">
            <TrophyIcon className="w-6 h-6 text-[#d4af37] mr-2" data-id="element-32" />
            <h3 className="text-lg font-light text-[#333333]" data-id="element-33">
              Verfijnde Gamification
            </h3>
          </div>
          <p className="text-[#666666] text-xs leading-relaxed" data-id="element-34">
            Subtiele gamification-elementen die passen bij een premium mentale
            gezondheidsapp, met balansreeksen, inzichtniveaus en ontgrendelbare
            content.
          </p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-35">
          <div className="flex items-center mb-2" data-id="element-36">
            <AwardIcon className="w-6 h-6 text-[#d4af37] mr-2" data-id="element-37" />
            <h3 className="text-lg font-light text-[#333333]" data-id="element-38">
              Betekenisvolle Beloningen
            </h3>
          </div>
          <p className="text-[#666666] text-xs leading-relaxed" data-id="element-39">
            Beloningen die echte waarde bieden: gepersonaliseerde inzichten,
            expertcontent en functionele tools die direct bijdragen aan mentaal
            welzijn.
          </p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-40">
          <div className="flex items-center mb-2" data-id="element-41">
            <LayersIcon className="w-6 h-6 text-[#d4af37] mr-2" data-id="element-42" />
            <h3 className="text-lg font-light text-[#333333]" data-id="element-43">
              Gelaagde Motivatie
            </h3>
          </div>
          <p className="text-[#666666] text-xs leading-relaxed" data-id="element-44">
            Een systeem dat zowel extrinsieke (beloningen, personalisatie) als
            intrinsieke motivatie (verbeterd welzijn, inzicht) stimuleert voor
            langdurige betrokkenheid.
          </p>
        </div>
      </div>
      <div className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-shadow mb-5" data-id="element-45">
        <h3 className="text-xl font-medium text-center text-[#333333] mb-3" data-id="element-46">
          Mosy's Gamification-voordelen
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3" data-id="element-47">
          <div className="flex items-start" data-id="element-48">
            <div className="w-7 h-7 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3 mt-0.5" data-id="element-49">
              <CheckSquareIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-50" />
            </div>
            <p className="text-xs text-[#666666] leading-relaxed" data-id="element-51">
              <span className="font-medium" data-id="element-52">Verhoogde retentie:</span>{' '}
              Gebruikers blijven langer betrokken door betekenisvolle progressie
              en beloningen
            </p>
          </div>
          <div className="flex items-start" data-id="element-53">
            <div className="w-7 h-7 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3 mt-0.5" data-id="element-54">
              <CheckSquareIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-55" />
            </div>
            <p className="text-xs text-[#666666] leading-relaxed" data-id="element-56">
              <span className="font-medium" data-id="element-57">Betere resultaten:</span>{' '}
              Consistente check-ins leiden tot effectievere mentale
              gezondheidszorg
            </p>
          </div>
          <div className="flex items-start" data-id="element-58">
            <div className="w-7 h-7 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3 mt-0.5" data-id="element-59">
              <CheckSquareIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-60" />
            </div>
            <p className="text-xs text-[#666666] leading-relaxed" data-id="element-61">
              <span className="font-medium" data-id="element-62">Premium uitstraling:</span>{' '}
              Verfijnde gamification versterkt de luxe ervaring in plaats van
              deze te verstoren
            </p>
          </div>
          <div className="flex items-start" data-id="element-63">
            <div className="w-7 h-7 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3 mt-0.5" data-id="element-64">
              <CheckSquareIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-65" />
            </div>
            <p className="text-xs text-[#666666] leading-relaxed" data-id="element-66">
              <span className="font-medium" data-id="element-67">Intrinsieke motivatie:</span>{' '}
              Gebruikers ontwikkelen een duurzame gewoonte van mentale zelfzorg
            </p>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-68">
          <button className="px-6 py-2 bg-[#d4af37] text-white rounded-full font-medium text-sm hover:bg-[#c9a42f] transition-colors" data-id="element-69">
            Implementeer Mosy's Gamification
          </button>
        </div>
      </div>
      <div className="flex justify-center items-center" data-id="element-70">
        <div className="bg-[#f7f3ef] p-3 rounded-full shadow-md" data-id="element-71">
          <HeartPulseIcon className="w-6 h-6 text-[#d4af37]" data-id="element-72" />
        </div>
        <h3 className="text-xl font-light text-[#333333] ml-3" data-id="element-73">mosy</h3>
      </div>
    </div>;
};